export const NOT_ALLOWED_POLICY = 'policy';
export const NOT_INTERESTING_MEETING = 'meeting';
export const NOT_INTERESTING_GIFT = 'gift';
export const ANOTHER_VARIANT = 'other';

export const DECLINE_REASONS = [
  { value: NOT_ALLOWED_POLICY, title: 'I am not allowed to receive any gifts due to company policy' },
  { value: NOT_INTERESTING_MEETING, title: 'I am not interested in the meeting' },
  { value: NOT_INTERESTING_GIFT, title: 'I do not want to receive this gift' },
];
